import { render, staticRenderFns } from "./TestingOrganizations.vue?vue&type=template&id=90cb4490"
import script from "./TestingOrganizations.vue?vue&type=script&lang=ts"
export * from "./TestingOrganizations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports